
import React, { useEffect, useState } from "react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) setVisible(true);
  }, []);

  const handleChoice = (value) => {
    localStorage.setItem("cookieConsent", value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      <style>{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        .cookie-sheet {
          animation: slideUp 0.45s ease-out;
        }

        @media (max-width: 768px) {
          .cookie-card {
            flex-direction: column !important;
            gap: 9px !important;
            padding: 10px 12px !important;
          }

          .cookie-content {
            width: 100%;
            text-align: center;
          }

          .cookie-title {
            font-size: 15px !important;
          }

          .cookie-text {
            font-size: 12px !important;
            line-height: 1.5 !important;
            margin-top: 5px !important;
          }

          .cookie-actions {
            width: 100%;
            max-width: 100% !important;
            flex-direction: row !important;
            gap: 10px !important;
          }

          .cookie-btn {
            flex: 1;
            width: auto;
            padding: 10px 12px !important;
            font-size: 14px !important;
          }

          .cookie-handle {
            display: none;
          }
        }
      `}</style>

      <div style={styles.wrapper}>
        <div style={styles.card} className="cookie-sheet cookie-card">
          <div style={styles.handle} className="cookie-handle" />

          <div style={styles.content} className="cookie-content">
            <h3 style={styles.title} className="cookie-title">
              שימוש בעוגיות (Cookies)
            </h3>

            <p style={styles.text} className="cookie-text">
              אתר זה עושה שימוש בקובצי Cookies וטכנולוגיות מעקב
              דומות לצורך הפעלה תקינה, שיפור ביצועים, ניתוח שימושים
              והתאמת חוויית המשתמש. אנו עשויים לאסוף מידע אנונימי
              סטטיסטי לשם שיפור השירותים. המשך השימוש באתר מהווה
              הסכמה לכך.{" "}
              <a
                href="/תקנון-שימוש%20באתר-הקמת%20אתרי%20אינטרנט%20לבעלי%20עסקים.pdf"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.link}
              >
                למדיניות הפרטיות המלאה
              </a>
            </p>
          </div>

          <div style={styles.actions} className="cookie-actions">
            <button
              className="cookie-btn"
              onClick={() => handleChoice("accepted")}
              style={{ ...styles.button, ...styles.accept }}
            >
              אישור
            </button>

            <button
              className="cookie-btn"
              onClick={() => handleChoice("declined")}
              style={{ ...styles.button, ...styles.decline }}
            >
              סירוב
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

const styles = {
  wrapper: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    width: "100%",
    zIndex: 2147483647,
    display: "flex",
    justifyContent: "center",
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
  },

  card: {
    width: "100%",
    maxWidth: "100%",
    background: "#0f172a",
    color: "#fff",
    borderTopLeftRadius: "14px",
    borderTopRightRadius: "14px",
    padding: "10px 22px",
    boxShadow: "0 -8px 30px rgba(0,0,0,0.3)",
    direction: "rtl",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    textAlign: "right",
    gap: "20px",
    boxSizing: "border-box",
  },

  handle: {
    display: "none",
  },

  content: {
    flex: 1,
    minWidth: 0,
  },

  title: {
    margin: 0,
    fontSize: "16px",
    fontWeight: "700",
  },

  text: {
    marginTop: "5px",
    marginBottom: 0,
    fontSize: "13px",
    color: "#d1d5db",
    lineHeight: "1.6",
  },

  link: {
    color: "#60a5fa",
    fontWeight: "700",
    textDecoration: "none",
    whiteSpace: "nowrap",
  },

  actions: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    width: "auto",
    maxWidth: "250px",
    flexShrink: 0,
    flexDirection: "row",
  },

  button: {
    flex: 1,
    border: "none",
    borderRadius: "10px",
    padding: "11px 22px",
    fontSize: "14px",
    fontWeight: "700",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },

  accept: {
    background: "linear-gradient(135deg,#3b82f6,#2563eb)",
    color: "#fff",
  },

  decline: {
    background: "rgba(255,255,255,0.08)",
    color: "#fff",
    border: "1px solid rgba(255,255,255,0.12)",
  },
};
